module.exports = __webpack_public_path__ + "img/login-img-sm.47e35911.png";